<template>
  <div class="error_page">
    <div class="error_img">
      <img src="../assets/getcoupons/icon_errors.png" />
    </div>
    <p class="error_p">出了点错误，请稍后重试(10012)</p>
    <button class="error_button" @click="errorbtn">重试</button>
    <van-popup v-model="show" class="ispopup" :overlay="true">
      <p class="title_p">确认使用1元购买此课程？</p>
      <p class="text_p">只有一次1元购课机会</p>
      <button class="cancel">取消</button>
      <button class="sure">确认购课</button>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Popup } from 'vant'

Vue.use(Popup)
export default {
  name: 'errorPage',
  data() {
    return {
      show: false
    }
  },
  methods: {
    errorbtn() {
      this.show = true
      // this.$router.go(0);
    }
  }
}
</script>
<style lang="less" scoped>
.error_page {
  width: 100%;
  min-height: 100vh;

  .error_img {
    position: relative;
    width: 100%;
    height: 360px;

    img {
      position: absolute;
      top: 260px;
      left: 50%;
      width: 120px;
      height: 100px;
      transform: translate(-50%);
    }
  }

  .error_p {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    line-height: 27px;
    text-align: center;
    color: #5b6169;
  }

  .error_button {
    position: absolute;
    left: 50%;
    width: 86px;
    height: 33px;
    margin-top: 23px;
    font-size: 13px;
    font-weight: 400;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    text-align: center;
    color: #fff;
    background: #00aced;
    border-radius: 17px;
    transform: translate(-50%);
  }

  .ispopup {
    width: 86%;
    height: 200px;
    overflow: hidden;
    border-radius: 4px;

    .title_p {
      width: 100%;
      padding-top: 53px;
      font-size: 21px;
      font-weight: 500;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      text-align: center;
      color: #222830;
    }

    .text_p {
      width: 100%;
      padding-top: 25px;
      font-size: 15px;
      font-weight: 400;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      text-align: center;
      color: #5b6169;
    }

    .cancel {
      float: left;
      width: 126px;
      height: 33px;
      margin: 30px 0 0 20px;
      background: #f3f3f4;
      border-radius: 17px;
    }

    .sure {
      float: left;
      width: 126px;
      height: 33px;
      margin: 30px 0 0 27px;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      text-align: center;
      color: #fff;
      background: #eb002a;
      border-radius: 17px;
    }
  }
}
</style>
